import React, { useEffect, useState } from "react";
import BreadCrumbs from "../../common/breadcrumbs";
import { useLocation, useNavigate } from "react-router";
import { Tab, Tabs } from "react-bootstrap";
import { URL } from "../../../constants/URL";
import PromoGiftsTable from "./PromoGiftsTable";
import ApprovalRequests from "./ApprovalRequests";

const TABS = {
	PROMO_GIFTS: "Promo Gifts",
	APPROVAL_REQUEST: "Approval Requests",
};

const PromoGifting = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const [activeTab, setActiveTab] = useState();
	const handleChangeTab = (val) => {
		setActiveTab(val);
		switch (val) {
			case TABS.PROMO_GIFTS:
				navigate(URL.promoGifts);
				break;
			case TABS.APPROVAL_REQUEST:
				navigate(URL.promoGiftApprovalRequests);
				break;
			default:
				navigate(URL.promoGifts);
				break;
		}
	};

	useEffect(() => {
		switch (location.pathname) {
			case URL.promoGifts:
				setActiveTab(TABS.PROMO_GIFTS);
				break;
			case URL.promoGiftApprovalRequests:
				setActiveTab(TABS.APPROVAL_REQUEST);
				break;
			default:
				setActiveTab(TABS.PROMO_GIFTS);
				break;
		}
	}, [location.pathname]);

	return (
		<React.Fragment>
			<BreadCrumbs title="Gift Management" data={[{ label: "Promo Gifts" }]} />
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="card notification-card tabs-block p-0">
						<Tabs
							className="pl-5 pt-3 tab-block"
							id="controlled-tab-example"
							activeKey={activeTab}
							onSelect={handleChangeTab}
						>
							<Tab eventKey={TABS.PROMO_GIFTS} title={TABS.PROMO_GIFTS}>
								<PromoGiftsTable />
							</Tab>
							<Tab
								eventKey={TABS.APPROVAL_REQUEST}
								title={TABS.APPROVAL_REQUEST}
							>
								<ApprovalRequests />
							</Tab>
						</Tabs>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default PromoGifting;
